import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';
import ProfilePic from '../ProfilePic';
import styles from './NavBar.module.css';
import NavButton from '../NavButton';

const NavBar = () => {
  const { isLoggedIn, setIsLoggedIn } = useContext(UserContext);

  const onLogOut = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('token');
  };

  return (
    <div className={styles.navbar}>
      {!isLoggedIn ? (
        <>
          <Link to="/signup">
            <NavButton text="Sign Up" style={{ marginRight: '2.75rem' }} />
          </Link>
          <Link to="/login">
            <NavButton text="Log In" size="large" />
          </Link>
        </>
      ) : (
        <>
          <NavButton
            text="Log Out"
            size="small"
            style={{ marginRight: '2.75rem' }}
            onClick={onLogOut}
          />
          <Link to={`/user/${isLoggedIn.username}`}>
            <ProfilePic
              size="medium"
              url={`${process.env.REACT_APP_SERVER_URL}/user/${isLoggedIn.username}/avatar`}
            />
          </Link>
        </>
      )}
    </div>
  );
};

export default NavBar;
